module.exports = __webpack_public_path__ + "img/05yffy.1720b7f2.svg";